import { rulesMessages } from '../../constants/rules.messages';
import { referralCodeFormConstant } from './referralCodeForm.constant';

/**
 * @type {{[key:string]:import('antd/es/form').Rule[]}}
 */
export const referralCodeRules = {
  [referralCodeFormConstant.ReferralCode]: [
    {
      min: 1,
      message: rulesMessages.referralCode.referralCodeMin,
    },
    {
      max: 15,
      message: rulesMessages.referralCode.referralCodeMax,
    },
    {
      pattern: /^(?!.* {2})[A-Za-z0-9 ]+$/,
      message: rulesMessages.referralCode.referralCodeCharacters,
    },
  ],
};
